import constants from '@/config/constants';
import { logger as loggerSentry } from '@sentry/react-native';

export function logError(message: string, error?: any) {
  /**
   * Diabled for now, as it's spamming the server with errors
   */

  // const userAgent = Platform.OS === 'web' && navigator.userAgent;
  // const { DeviceType, ...device } = Device;
  // const deviceInfo = {
  //   brand: device?.brand,
  //   designName: device?.designName,
  //   deviceName: device?.deviceName,
  //   deviceType: device?.deviceType,
  //   deviceYearClass: device?.deviceYearClass,
  //   isDevice: device?.isDevice,
  //   manufacturer: device?.manufacturer,
  //   modelId: device?.modelId,
  //   modelName: device?.modelName,
  //   osBuildFingerprint: device?.osBuildFingerprint,
  //   osBuildId: device?.osBuildId,
  //   osInternalBuildId: device?.osInternalBuildId,
  //   osName: device?.osName,
  //   osVersion: device?.osVersion,
  //   platformApiLevel: device?.platformApiLevel,
  //   supportedCpuArchitectures: device?.supportedCpuArchitectures,
  //   totalMemory: device?.totalMemory,
  // };
  // const errorInfo = {
  //   incidentId: incidentId ?? null,
  //   error: {
  //     message: `${message} # ${error?.message}`,
  //     stack: error?.stack,
  //   },
  //   device: {
  //     userAgent: userAgent || undefined,
  //     ...(!userAgent && deviceInfo),
  //   },
  // };

  // if (isProduction) {
  //   store.getActions().addError(errorInfo);
  //   return;
  // }
  if (constants.sentryEnabled) {
    loggerSentry.error(message, {
      error,
    });
    return;
  }
  /* eslint-disable no-console */
  if (constants.environment === 'production') return;
  if (message) console.error('\x1b[41m\x1b[37m ERROR', message);
  if (error) console.error(error);
}

export function logInfo(message: any, ...addInfo: any[]) {
  if (constants.environment === 'production') return;
  if (message) console.info(message, ...addInfo);
}
